module.exports = __webpack_public_path__ + "static/media/video.f4823ef.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video.mp4
// module id = q3HI
// module chunks = 1